import request, { requestV2 } from "@/config/serve.js";
import { MAXSIZE } from "@/common/constant/constant.js";

// 查询
export function getMarketReleaseList(params) {
  return requestV2("post", "/marketPublish/queryList", params);
}
//新增
export function addMarketRelease(data) {
  return requestV2("post", "/marketPublish/insert", data);
}
//修改
export function updateMarketRelease(data) {
  return requestV2("post", "/marketPublish/update", data);
}
// 获取市场列表
export function getMarketList(params) {
  return request("post", "/market/manage/queryList", {
    page: 1,
    size: MAXSIZE,
    ...params,
    isDelete: 0,
  });
}
